import { useCallback, useEffect, useMemo, useState } from 'react';

const DEFAULT_PAGE_SIZE = 25;

/**
 * Client-side infinite scroll for Platform timesheet tables.
 * Resets when `resetKey` changes (e.g. filters).
 */
export const useInfiniteRows = (
  rows = [],
  { pageSize = DEFAULT_PAGE_SIZE, resetKey } = {},
) => {
  const [visibleCount, setVisibleCount] = useState(pageSize);

  useEffect(() => {
    setVisibleCount(pageSize);
  }, [resetKey, pageSize]);

  const visibleRows = useMemo(() => rows.slice(0, visibleCount), [
    rows,
    visibleCount,
  ]);

  const hasMore = visibleCount < rows.length;

  const onTableScroll = useCallback(
    event => {
      if (!hasMore) return;
      const el = event.currentTarget;
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - 96) {
        setVisibleCount(count => Math.min(count + pageSize, rows.length));
      }
    },
    [hasMore, pageSize, rows.length],
  );

  return {
    visibleRows,
    hasMore,
    onTableScroll,
    visibleCount,
    totalCount: rows.length,
  };
};

export default useInfiniteRows;
